import reducer from './modules.reducer';
import * as selector from './modules.selector';
import * as constant from './modules.constant';
import subscriber from './modules.subscriber';
import saga from './modules.saga';

export default {
  reducer,
  constant,
  selector,
  subscriber,
  saga,
  name: constant.NAME,
};
